import { Container, Grid } from '@material-ui/core'
import React, { useState, useEffect, useMemo } from 'react'
import { ButtonHLPure, ComboBoxTemplatePure, DialogPdf, DialogSystemGLPure, DialogYesNoHLPure, DropDownBtnHLPure, GridSelectionHLPure, HeaderHLPure, InputHLPure, PanelBarGLPure, PromotionalFooterPure, SimpleLoading, DialogPdfHLPure, CheckBoxHLPure, LabelErrorPure, InstructionsPure, LabelModalPure, LabelHLPure } from '../../pures'
import './digital-vault-upload.css'
import { TreeView, processTreeViewItems } from '@progress/kendo-react-treeview';
import { DocumentsRequest } from '../../../assets/logos/icons';
import { useMediaQuery } from '@material-ui/core'
import PdfReader from '../../pures/adobePfdReader/PdfReader';
import { PanelBar, PanelBarItem } from '@progress/kendo-react-layout';
import { useTranslation } from "react-i18next";

const getSubcategoryPath = (tree, id, path = []) => {
    for (let i = 0; i < tree.length; i++) {
        const element = tree[i];
        if (element.subcategory.id == id) {
            return [...path, element.subcategory.id];
        }
        const nextLevelSearch = getSubcategoryPath(element.items || [], id, [...path, element.subcategory.id])
        if (nextLevelSearch) return nextLevelSearch
    }
}

const traceSubcategoryPath = (tree, path, hierarchicalIndex = "") => {
    if (path.length == 0) return hierarchicalIndex.slice(1)

    let catIndex = tree.findIndex(i => i.subcategory.id == path[0]);
    if (catIndex != -1) {
        return traceSubcategoryPath(tree[catIndex].items || [], path.slice(1), `${hierarchicalIndex}_${catIndex}`)
    } else {
        return [];
    }
}


const HeaderColumns = (props) => {
    return (
        <span className={(props.title === props.t("digitalVaultUploadView.grid.title.1") || props.title === props.t("digitalVaultUploadView.modal.entities.grid.title.1")) ? "grid-header-one" : "grid-headers"}>{props.title}</span>
    );
};

const CellColumnOne = (props) => {
    const {
        dataItem,
    } = props;

    return (
        <td className={`digitalVaultUploadView-col1 ${dataItem.selected ? "selected" : ""}`}>
            <div>
                <p className='grid-cell-titles-margin-left'>{dataItem.name}</p>
            </div>
        </td>
    )
}

const DigitalVaultUploadView = (props) => {
    const {
        isLoading,
        showLoadingRequesting,
        toggleErrorRequesting,
        showCompletedRequesting,
        toggleLoadingRequesting,
        showErrorRequesting,
        toggleCompletedRequesting,
        messageError,
        fileType,
        infoTypes,
        companies,
        categories,
        subcategoryTree,
        typeDocuments,
        handleFile,
        deleteFile,
        uploadData,
        handleUploadDataChange,

        onCancel,
        onSave,
        invalidFields,
        setInvalidFields,

        documentId,
        handleUpdateDocument,
        urlPdf,
        blobAWS,
        handleWathchExp,

        showUploadBtn,
        showBtnCancel,
        rejectUploadDocument,
        showDialogSendDocToOcr,
        closeModalSendToOcr,
        documentsToOCR,
        handleCheckBoxDoc,
        totalCredits,
        setFileType
    } = props;

    const { t } = useTranslation()
    const [viewCancelDialog, setViewCancelDialog] = useState(false);
    const [showRejectDialog, setShowRejectDialog] = useState(false)
    const [realFileType, setRealFileType] = useState("")

    const mobileResolution = useMediaQuery("(max-width:560px)");
    const is820 = useMediaQuery("(max-width:820px)");
    const is560 = useMediaQuery("(max-width:560px)");

    let heightContainer = mobileResolution ? 550 : 610
    let widthContainer = mobileResolution ? 550 : 820
    let heightBody = mobileResolution ? 230 : 370

    if (is560) heightContainer = 605

    const pdfAWS = useMemo(() => <PdfReader useFullHeight className="pdfReader" url={urlPdf} awsURL showDownloadPDF={false} />, [urlPdf])

    const cellColumnOne = (props) => {
        return (
            <td>
                <div className='grid-cell-double-container-margin-left'>
                    <p className='grid-cell-titles'>{props.dataItem.name}</p>
                    <p className='grid-cell-subtitles'>{`${props.dataItem.pages} ${t("digitalVaultUploadView.pages")}`}</p>
                </div>
            </td>
        );
    };

    useEffect(() => {
        setRealFileType(fileType)
    }, [fileType])

    const cellColumnTwo = (props) => {
        return (
            <td>
                <div>
                    <p className="grid-cell-subtitles">{props.dataItem.process}</p>
                </div>
            </td>
        );
    };

    const cellColumnThree = (props) => {
        return (
            <td >
                <div>
                    <p className="grid-cell-subtitles">
                        {props.dataItem.unitary}
                    </p>
                </div>
            </td>
        );
    };

    const cellColumnFour = (props) => {
        return (
            <td>
                <div className='digitalVaultUploadView-cell-four-checkbox'>
                    <CheckBoxHLPure
                        valueCheckBox={props.dataItem.value}
                        checkedState={props.dataItem.value}
                        onChangeHandler={(e) => handleCheckBoxDoc(e, props.dataItem)}
                    />
                </div>
            </td>
        );
    };

    const cellColumnSix = (props) => {
        return (
            <td>
                <div>
                    <p className="grid-cell-subtitles">
                        {props.dataItem.credits}
                    </p>
                </div>
            </td>
        );
    };

    let heightGrid = 'auto'
    if (documentsToOCR.length >= 3) heightGrid = '320px'

    const onDataChange = (event, field) => {
        let value;

        if (field == "typeDocument") {
            value = event.value;
            if (value && value.id === undefined) {
                value = {
                    ...value,
                    id: -1,
                };
            }
        } else if (field == "pathBreadcrumb") {
            setSelected([event.itemHierarchicalIndex]);
            const path = getSubcategoryPath(subcategoryTree, event.item.subcategory.id)
            value = path
        } else if (field == "categoryId") {
            value = parseInt(event.target.value)
        } else {
            value = event.target.value
        }

        setInvalidFields(prev => prev.filter(i => i !== field))
        handleUploadDataChange(field, value);
    }

    useEffect(() => {
        if (subcategoryTree.length && uploadData.pathBreadcrumb && uploadData.pathBreadcrumb.length) {
            const hierarchicalIndex = traceSubcategoryPath(subcategoryTree, uploadData.pathBreadcrumb)
            setSelected([hierarchicalIndex]);
            setExpand(prev => ({
                ids: [...new Set([...prev.ids, ...uploadData.pathBreadcrumb])],
                idField: "subcategory.id"
            }))
        } else {
            setSelected([""]);
            setExpand({
                ids: [],
                idField: "subcategory.id"
            })
        }
    }, [uploadData.pathBreadcrumb])


    const [selected, setSelected] = useState([""]);
    const [expand, setExpand] = useState({
        ids: [],
        idField: "subcategory.id",
    });

    const onTreeExpandChange = (event) => {
        let ids = expand.ids.slice();
        const index = ids.indexOf(event.item.subcategory.id);
        index === -1 ? ids.push(event.item.subcategory.id) : ids.splice(index, 1);
        setExpand({
            ids,
            idField: "subcategory.id",
        });
    };

    const [fileShown, setFileShown] = useState({});
    const pdf = useMemo(() => <PdfReader className="pdfReader" file={fileShown.file ? fileShown.fileBase64 : ''} isFile src={`data:application/pdf;base64,${fileShown.file ? fileShown.fileBase64 : ''}`}  ></PdfReader>, [fileShown]);

    useEffect(() => {
        let files = uploadData.uploadedFiles
        if (files.length == 0) setFileShown({});
        else if (files.length == 1) setFileShown(files[0]);
        else if (files.findIndex(f => f.name == fileShown.name && f.fileBase64 == f.fileBase64) == -1) setFileShown(files[0]);
    }, [uploadData.uploadedFiles])

    const [fileSelected, setFileSelected] = useState({});
    useEffect(() => {
        if (!fileSelected || !fileSelected.fileBase64) return
        setFileShown(fileSelected)
    }, [fileSelected])

    let skip = 0;
    if (fileShown.file) {
        const i = uploadData.uploadedFiles.findIndex(f => f.name == fileShown.name && f.fileBase64 == f.fileBase64)
        if (i !== -1) skip = Math.floor(i / 5) * 5
    }

    const uploadDocumentFromDialog = (ocrSelected) => {
        closeModalSendToOcr()
        if (documentId) handleUpdateDocument(null, ocrSelected)
        else onSave(null, ocrSelected)
    }

    let AllHeadersColumns = (props) => <HeaderColumns {...props} t={t} />

    let widthColumnOne = '100px'
    let widthColumnFive = '50px'

    //TODO: funcion para arrastrar y soltar archivos + mas modal de validacion de nuevo documento
    const [showAlert, setShowAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState("");

    const showAlertDialog = (message) => {
        setMessageAlert(message);
        setShowAlert(true);
    };

    const closeAlertDialog = () => {
        setShowAlert(false);
    };

    const handleDrop = async (e) => {
        e.preventDefault();

        const files = e.dataTransfer.files;

        if (uploadData.infoType == 1) {
            if (files.length > 1) {
                showAlertDialog(t("digitalVaultUploadView.description.rule"));
                return;
            } else {
                await handleFile({ target: { files } });
            }
        }
        if (uploadData.infoType == 2) {
            if (files.length > 0) {
                await handleFile({ target: { files } });
            }
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };


    return (
        <>
            <div className='standard-wrapper'>
                {
                    isLoading
                        ? <SimpleLoading />
                        : <>
                            <Container>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <HeaderHLPure title={`${uploadData.infoType == 1 ? t("digitalVaultUploadView.title.document") : t("digitalVaultUploadView.title.exp")}`} />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <PanelBarGLPure
                                            expandedPanel={true}
                                            titlePanel={`${uploadData.infoType == 1 ? t("digitalVaultUploadView.data.document") : t("digitalVaultUploadView.data.exp")}`}
                                        >
                                            <div className='digitalVaultUploadView-data'>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12}>
                                                        <DropDownBtnHLPure
                                                            labelDropDown={t("digitalVaultUploadView.storage.type")}
                                                            optionsDropDown={infoTypes}
                                                            optionsValue={uploadData.infoType}
                                                            valueItem={"id"}
                                                            nameOption={"name"}
                                                            onDropDownChange={(e) => onDataChange(e, "infoType")}
                                                            required
                                                            disable={(documentId) ? true : false}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <InputHLPure
                                                            labelInput={uploadData.infoType == 1 ? t("digitalVaultUploadView.document.name") : t("digitalVaultUploadView.document.exp")}
                                                            inputActive
                                                            valueInput={uploadData.name}
                                                            handleChangeInput={(e) => onDataChange(e, "name")}
                                                            typeInput={"text"}
                                                            characterLimit={128}
                                                            errorInput={invalidFields.includes("name")}
                                                            errorInputText={t("digitalVaultUploadView.errors.name")}
                                                            required
                                                        />
                                                    </Grid>

                                                    {
                                                        uploadData.infoType == 2 &&
                                                        <Grid item xs={12} className='digitalVaultUploadView-grid'>
                                                            <GridSelectionHLPure
                                                                skip={skip}
                                                                take={5}
                                                                pageable
                                                                dataGrid={uploadData.uploadedFiles.map(f => f.name == fileShown.name && f.fileBase64 == fileShown.fileBase64 ? { ...f, selected: true } : { ...f })}
                                                                noRecordsMessage={t("digitalVaultUploadView.errors.no.records")}

                                                                titleRow1={t("digitalVaultUploadView.grid.title.1")}
                                                                cellColumnOne={CellColumnOne}
                                                                headerColumnOne={AllHeadersColumns}
                                                                widthColumnOne={widthColumnOne}
                                                                minResizableWidth1={'auto'}

                                                                columnFive
                                                                headerColumnFiveClass={"grid-headers"}
                                                                columnFiveStyleClass={"digitalVaultUploadView-cellActions"}
                                                                titleRow5={t("digitalVaultUploadView.grid.title.5")}
                                                                iconOneActive
                                                                labelOneActions={t("digitalVaultUploadView.grid.btns.view.document")}
                                                                activeDialog1
                                                                btnOpenDialog1={(!documentId) ? (dataItem) => {
                                                                    setFileType(dataItem.fileType)
                                                                    setFileShown(dataItem)
                                                                } :
                                                                    (dataItem) => handleWathchExp(dataItem)
                                                                }
                                                                iconTrashActive={(!documentId) ? true : false}
                                                                labelTrashActions={t("digitalVaultUploadView.grid.btns.delete")}
                                                                activeDialogTrash={(!documentId) ? true : false}
                                                                btnOpenDialogTrash={(dataItem) => deleteFile(dataItem)}
                                                                tooltipTrashIcon={t("button.delete")}
                                                                widthColumnFive={widthColumnFive}
                                                                minResizableWidth5={widthColumnFive}

                                                                onSelectedItem={setFileSelected}
                                                                setNameComponentUser={() => { }}
                                                                setShowDetails={() => { }}
                                                            />
                                                        </Grid>
                                                    }

                                                    <Grid item xs={12}>
                                                        <DropDownBtnHLPure
                                                            labelDropDown={t("digitalVaultUploadView.company")}
                                                            optionsDropDown={companies}
                                                            optionsValue={uploadData.companyId}
                                                            valueItem={"id"}
                                                            nameOption={"companyName"}
                                                            onDropDownChange={(e) => onDataChange(e, "companyId")}
                                                            required
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <DropDownBtnHLPure
                                                            labelDropDown={t("digitalVaultUploadView.catgory")}
                                                            optionsDropDown={categories}
                                                            optionsValue={uploadData.categoryId}
                                                            valueItem={"id"}
                                                            nameOption={"name"}
                                                            onDropDownChange={(e) => onDataChange(e, "categoryId")}
                                                            required
                                                        />
                                                        {
                                                            invalidFields.includes("categoryId") &&
                                                            <LabelErrorPure label={t("digitalVaultUploadView.errors.select.category")} />
                                                        }
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <p className="inputHLPure-label">{t("digitalVaultUploadView.subcategory")} *</p>
                                                        {
                                                            invalidFields.includes("pathBreadcrumb") &&
                                                            <LabelErrorPure label={t("digitalVaultUploadView.errors.select.subcategory")} />
                                                        }

                                                        {subcategoryTree.length == 0
                                                            ? <p className='digitalVaultUploadView-not-assigned'>{t("digitalVaultUploadView.unassigned")}</p>
                                                            : <TreeView
                                                                data={processTreeViewItems(subcategoryTree, {
                                                                    select: selected,
                                                                    expand: expand,
                                                                })}
                                                                expandIcons
                                                                size={"medium"}
                                                                textField='subcategory.name'
                                                                onExpandChange={onTreeExpandChange}
                                                                onItemClick={(e) => onDataChange(e, "pathBreadcrumb")}
                                                            />
                                                        }
                                                    </Grid>

                                                    <ComboBoxTemplatePure
                                                        title={t("digitalVaultUploadView.document.type")}
                                                        placeholder={t("digitalVaultUploadView.select.document.type")}
                                                        allowCustom
                                                        data={typeDocuments}
                                                        textField="name"
                                                        dataItemKey="id"
                                                        value={uploadData.typeDocument}
                                                        onChange={(e) => onDataChange(e, "typeDocument")}
                                                        required
                                                        validityStyles={false}
                                                        errorCombobox={invalidFields.includes("typeDocument")}
                                                        errorMessage={t("digitalVaultUploadView.errors.select.document.type")}
                                                    />
                                                </Grid>
                                            </div>
                                        </PanelBarGLPure>
                                    </Grid>

                                    {
                                        showUploadBtn ?
                                            (
                                                <Grid item xs={12} md={6} onDragOver={handleDragOver} onDrop={handleDrop}>
                                                    <DialogSystemGLPure
                                                        showWarningRequesting={showAlert}
                                                        message={messageAlert}
                                                        toggleWarningRequesting={closeAlertDialog}
                                                    />
                                                    <Grid container spacing={3} alignContent='flex-start'>
                                                        <Grid item xs={12}>
                                                            <div className='digitalVaultUploadView-upload'>
                                                                <Grid container spacing={2} className='digitalVaultUploadView-file-container'>
                                                                    <Grid item xs={8}>
                                                                        {
                                                                            uploadData.infoType == 1 ?
                                                                                <InstructionsPure
                                                                                    instructions={[
                                                                                        <>
                                                                                            {t("digitalVaultUploadView.instructions.1.document")} <strong>
                                                                                                {t("digitalVaultUploadView.instructions.1.document_strong")}
                                                                                            </strong>.
                                                                                        </>
                                                                                        ,
                                                                                        <>
                                                                                            {t("digitalVaultUploadView.instructions.2.document")} <strong>
                                                                                                {t("digitalVaultUploadView.instructions.2.document_strong")}
                                                                                            </strong>.
                                                                                        </>
                                                                                        ,
                                                                                        t("digitalVaultUploadView.instructions.3.document"),
                                                                                    ]}
                                                                                /> : uploadData.infoType == 2 ?
                                                                                    <InstructionsPure
                                                                                        instructions={[
                                                                                            <>
                                                                                                {t("digitalVaultUploadView.instructions.1.file")} <strong>
                                                                                                    {t("digitalVaultUploadView.instructions.1.file_strong")}
                                                                                                </strong>.
                                                                                            </>,
                                                                                            <>
                                                                                                {t("digitalVaultUploadView.instructions.2.file")} <strong>
                                                                                                    {t("digitalVaultUploadView.instructions.2.file_strong")}
                                                                                                </strong>.
                                                                                            </>,
                                                                                            t("digitalVaultUploadView.instructions.3.file"),
                                                                                            t("digitalVaultUploadView.instructions.4.file"),
                                                                                        ]}
                                                                                    /> : null
                                                                        }
                                                                    </Grid>
                                                                    <Grid item xs={4}>
                                                                        <div>
                                                                            <label for="file-upload" className='digitalVaultUploadView-file-upload'>
                                                                                <input
                                                                                    type="file"
                                                                                    //accept="application/pdf"
                                                                                    id="file-upload"
                                                                                    required
                                                                                    multiple={uploadData.infoType == 2}
                                                                                    onClick={(e) => (e.target.value = null)}
                                                                                    onChange={handleFile}
                                                                                />
                                                                                <img src={DocumentsRequest} />
                                                                                <span style={invalidFields.includes("files") ? { color: 'red' } : null}>{t("digitalVaultUploadView.upload.file")}{uploadData.infoType == 2 && "(s)"}</span>
                                                                                <span className='digitalVaultUploadView-file-upload-text'>{t("digitalVaultUploadView.upload.required")}</span>
                                                                            </label>
                                                                        </div>
                                                                    </Grid>
                                                                </Grid>
                                                            </div>
                                                        </Grid>
                                                        {uploadData.uploadedFiles.length && fileShown.file
                                                            ?
                                                            <>
                                                                {
                                                                    fileType === "pdf" &&
                                                                    <Grid item xs={12}>
                                                                        {pdf}
                                                                    </Grid>
                                                                }
                                                                {
                                                                    fileType === "image" &&
                                                                    <Grid item xs={12}>
                                                                        <img
                                                                            src={`data:${fileShown.type};base64,${fileShown.fileBase64}`}
                                                                            width={"100%"}
                                                                            height={"100%"}
                                                                        />
                                                                    </Grid>
                                                                }
                                                                {
                                                                    fileType === "video" &&
                                                                    <Grid item xs={12}>
                                                                        <video
                                                                            src={`data:${fileShown.type};base64,${fileShown.fileBase64}`}
                                                                            controls
                                                                            disablePictureInPicture
                                                                            disableRemotePlayback
                                                                            width={"100%"}
                                                                            height={"100%"}
                                                                        />
                                                                    </Grid>
                                                                }
                                                            </>
                                                            : null
                                                        }
                                                    </Grid>
                                                </Grid>
                                            ) : (
                                                <>
                                                    {
                                                        realFileType === "pdf"
                                                        && <Grid item xs={12} md={6}>
                                                            <div className='followUpDocumentEntities-documentPDF' >
                                                                <div className='followUpDocumentEntities-documentPDF-container'>
                                                                    {pdfAWS ? pdfAWS : null}
                                                                </div>
                                                                <div className="followUpDocumentEntities-documentPDF-pdf-btn">
                                                                    <DialogPdf blobUrl={blobAWS} />
                                                                </div>
                                                            </div>
                                                        </Grid>
                                                    }
                                                    {
                                                        realFileType === "image" &&
                                                        <Grid item xs={12} md={6}>
                                                            <div className='followUpDocumentEntities-documentPDF' >
                                                                <div className='followUpDocumentEntities-documentPDF-container'>
                                                                    <img
                                                                        src={urlPdf}
                                                                        width={"100%"}
                                                                        height={"100%"}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </Grid>
                                                    }
                                                    {realFileType === "video" &&
                                                        <Grid item xs={12} md={6}>
                                                            <div className='followUpDocumentEntities-documentPDF' >
                                                                <div className='followUpDocumentEntities-documentPDF-container'>
                                                                    <video
                                                                        src={urlPdf}
                                                                        controls
                                                                        disablePictureInPicture
                                                                        disableRemotePlayback
                                                                        width={"100%"}
                                                                        height={"100%"}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </Grid>
                                                    }
                                                </>
                                            )
                                    }

                                    <Grid container item xs={12} justify='flex-end' className='digitalVaultUploadView-buttongroup'>
                                        <ButtonHLPure
                                            nameBtn={t("button.cancel")}
                                            onClickBtn={(e) => setViewCancelDialog(true)}
                                        />
                                        {
                                            showBtnCancel && (
                                                <ButtonHLPure
                                                    nameBtn={t("button.reject")}
                                                    onClickBtn={() => setShowRejectDialog(true)}
                                                />
                                            )
                                        }
                                        <ButtonHLPure
                                            nameBtn={t("button.save")}
                                            primary
                                            onClickBtn={(documentId) ? (() => handleUpdateDocument(true)) : () => onSave(true)}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <PromotionalFooterPure />
                                    </Grid>
                                </Grid>
                            </Container>
                            {
                                viewCancelDialog && <DialogYesNoHLPure
                                    cancel={() => {
                                        setViewCancelDialog(false);
                                    }}
                                    textBtnCancel={t("button.no")}
                                    saveBtn={t("button.yes")}
                                    titleDialog={t("digitalVaultUploadView.modal.title")}
                                    handleSubmit={onCancel}
                                >
                                    <div className='digitalVaultUploadView-modal'>
                                        <LabelModalPure label={t("digitalVaultUploadView.modal.question")} />
                                        <LabelModalPure label={t("digitalVaultUploadView.modal.label")} />
                                    </div>
                                </DialogYesNoHLPure>
                            }
                            {
                                showRejectDialog && (
                                    <DialogYesNoHLPure
                                        cancel={() => {
                                            setShowRejectDialog(false);
                                        }}
                                        textBtnCancel={t("button.cancel")}
                                        saveBtn={t("button.accept")}
                                        titleDialog={t("digitalVaultUploadView.modal.reject.title")}
                                        handleSubmit={(e) => {
                                            setShowRejectDialog(false)
                                            rejectUploadDocument(e)

                                        }}
                                    >
                                        <div className='digitalVaultUploadView-modal-reject'>
                                            <LabelModalPure label={t("digitalVaultUploadView.modal.reject.question")} />
                                            <LabelModalPure label={t("digitalVaultUploadView.modal.reject.label")} />
                                        </div>
                                    </DialogYesNoHLPure>
                                )
                            }
                            {
                                showDialogSendDocToOcr && (
                                    <DialogPdfHLPure
                                        title={t("digitalVaultUploadView.modal.entities.title")}
                                        description={t("digitalVaultUploadView.modal.entities.description")}
                                        canelBtn={t("button.cancel")}
                                        width={widthContainer}
                                        height={heightContainer}
                                        heightBody={heightBody}
                                        saveBtn={t("digitalVaultUploadView.modal.entities.btn.save")}
                                        handleSubmitProfile={() => uploadDocumentFromDialog('Extraer entidades')}
                                        cancel={() => closeModalSendToOcr()}
                                        showExtraBtn={true}
                                        extrabtnlabel={t("digitalVaultUploadView.modal.entities.btn.skip.process")}
                                        handleExtraBtn={() => uploadDocumentFromDialog('Saltar proceso')}
                                    >
                                        <div className={(documentsToOCR.length >= 3) ? "digitalVaultView-data scroll" : "digitalVaultUploadView-grid-documents"}>
                                            <GridSelectionHLPure
                                                styleGeneral={true}
                                                styleGeneralClass={"digitalVaultUploadView-general-grid"}
                                                pageable={false}
                                                skip={0}
                                                take={documentsToOCR.length}
                                                dataGrid={documentsToOCR}
                                                filter={true}

                                                columnTwo={is820 ? false : true}
                                                columnThree={is820 ? false : true}
                                                columnFour={true}
                                                columnSix={true}

                                                titleRow1={t("digitalVaultUploadView.modal.entities.grid.title.1")}
                                                titleRow2={t("digitalVaultUploadView.modal.entities.grid.title.2")}
                                                titleRow3={t("digitalVaultUploadView.modal.entities.grid.title.3")}
                                                titleRow4={t("digitalVaultUploadView.modal.entities.grid.title.3")}
                                                titleRow6={t("digitalVaultUploadView.modal.entities.grid.title.6")}

                                                headerColumnOne={AllHeadersColumns}
                                                headerColumnTwo={AllHeadersColumns}
                                                headerColumnThree={AllHeadersColumns}
                                                headerColumnFour={AllHeadersColumns}
                                                headerColumnSix={AllHeadersColumns}

                                                cellColumnOne={cellColumnOne}
                                                cellColumnTwo={cellColumnTwo}
                                                cellColumnThree={cellColumnThree}
                                                cellColumnFour={cellColumnFour}
                                                cellColumnSix={cellColumnSix}

                                                widthColumnOne={'100px'}
                                                widthColumnTwo={'50px'}
                                                widthColumnThree={'70px'}
                                                widthColumnFour={'30px'}
                                                widthColumnSix={'30px'}

                                                minResizableWidth1={'auto'}
                                                minResizableWidth2={'50px'}
                                                minResizableWidth3={'70px'}
                                                minResizableWidth4={'30px'}
                                                minResizableWidth5={'30px'}

                                                styleGrid={{ height: heightGrid }}
                                            />
                                        </div>
                                        <div className='digitalVaultUploadView-container-total'>
                                            <LabelHLPure text={`${t("digitalVaultUploadView.modal.entities.total.credits")}: ${totalCredits}`} fontSize='18px' />
                                        </div>
                                    </DialogPdfHLPure>

                                )
                            }
                            <DialogSystemGLPure
                                showLoadingRequesting={showLoadingRequesting}
                                toggleLoadingRequesting={toggleLoadingRequesting}

                                showCompletedRequesting={showCompletedRequesting}
                                toggleCompletedRequesting={toggleCompletedRequesting}

                                showErrorRequesting={showErrorRequesting}
                                toggleErrorRequesting={toggleErrorRequesting}
                                messageError={messageError} />
                        </>
                }
            </div>
        </>
    )
}

export default DigitalVaultUploadView